export default {
    search(data) {
        return axios.post('/frontend/transit/search', data)
    }
}
